<template>
	<div class="usage-guide hidden-sm-and-down" @click="linkTo">
		<i class="icon icon-question"></i>
		<span>{{$t('usage')}}</span>
	</div>
</template>

<script>
export default {
	name: 'usage',
	methods: {
		linkTo() {
			this.$router.push({
				name: 'usage'
			});
		}
	}
};
</script>


<style lang="scss" scoped>
.usage-guide {
	padding-left: 15px;
	i {
		cursor: pointer;
	}
}
</style>
